import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ExpertiseSection from './components/ExpertiseSection';
import ApproachSection from './components/ApproachSection';
import PrinciplesSection from './components/PrinciplesSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <AboutSection />
      <ExpertiseSection />
      <ApproachSection />
      <PrinciplesSection />
      <ContactSection />
    </main>
  );
}